import type { Filter, FilterDataRange } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';
import { usePriceFilterTitle } from '@/app/common/filters/surfaces/forms/custom/usePriceFilterScale.ts';
import type { SliderBound } from '@/app/components/search/components/Slider/index.tsx';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';

// Names and value texts for the budget slider's thumbs: the visible title plus the Min/Max word of
// the field beside it, and the price (or 'no limit') that field shows. The filter is the scaled one.
// The title is the heading the surface shows (the group's in All filters, the filter's in the pill
// overlay), so the name always contains the visible label.
export const usePriceSliderThumbs = (filter: Filter, sectionTitle?: string) => {
  const { t } = useTranslation();
  const { localization } = useFiltersUiData();
  const priceTitle = usePriceFilterTitle();

  const title =
    sectionTitle || (filter.name === FILTER_NAME.PRICE_RANGE && priceTitle) || (filter.data as FilterDataRange).label;
  const nameFor = (boundLabel: string) => (boundLabel ? [title, boundLabel].filter(Boolean).join(', ') : '');

  return {
    thumbNames: {
      min: nameFor(t('vacation.oss.filters.budget.min_price')),
      max: nameFor(t('vacation.oss.filters.budget.max_price')),
    },
    valueText: (value: number, bound: SliderBound, atTop: boolean) =>
      bound === 'max' && atTop
        ? t('vacation.oss.components.searchfilters.labels.nolimit')
        : formatPrice({ price: value, localization }),
  };
};
